export const CatalogStages = () => {}
